import { createFeatureSelector } from '@ngrx/store';
import { ApplicationState } from './application.state';

export const applicationKey = 'application';
export const getApplicationState = createFeatureSelector<ApplicationState>(applicationKey);
